export default class MissingStarterException {
  public message: string
  constructor(message: string) {
    this.message = message
  }
}
